<template>
  <div class="page-content-pc">
    <div class="banner gsap-fade-down">
      <div class="introduce">
        <div class="introduce_title">
          让电商服务拥有「智慧温度」
        </div>
        <div class="introduce_desc">
          <div>七鼠智服——基于千亿大模型的AI客服系统</div>
          <div>为电商企业实现人力解放、体验升级与增长加速</div>
        </div>
      </div>
    </div>

    <div class="content">
      <!-- 统计板块 -->
      <div class="statistics-section gsap-fade-up">
        <div class="statistics-inner">
          <div class="statistics-item" v-for="item in statisticsList" :key="item.title">
            <img :src="item.icon" :alt="item.title" class="statistics-icon" />
            <div class="statistics-info">
              <div class="statistics-value">{{ item.currentValue }}<span v-if="item.title !== '注册用户'">{{ item.title ===
                '问题处理率' || item.title === '客户满意度' || item.title === '释放人力' ? '%' : '' }}</span><span
                  v-if="item.title === '注册用户'">+</span>
              </div>
              <div class="statistics-title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 统计板块结束 -->

      <!-- 产品介绍板块 -->
      <div class="product-section">
        <div class="product-left">
          <div class="product-title">七鼠智服</div>
          <div class="product-subtitle">一款接入千亿级大模型的电商AI智能客服系统</div>
          <div class="product-desc">
            七鼠智服精准锚定大型电商平台、中小型电商企业、新兴电商企业等核心客户群体。大型电商平台面临海量咨询压力，急需高效智能客服系统提升服务效率；中小型电商企业渴望以低成本实现服务升级；新兴电商企业则希望借助智能客服构建差异化竞争优势，这为我们提供了广阔的市场空间
          </div>
        </div>
        <div class="product-right">
          <div v-if="!productVideoPlaying" class="product-cover-wrap">
            <img :src="productCover" alt="产品介绍封面" class="product-cover-img" />
            <div class="product-play-btn" @click="playproductVideo">
              <svg viewBox="0 0 42 58" width="100%" height="100%">
                <polygon points="0,0 42,29 0,58" fill="#999" />
              </svg>
            </div>
          </div>
          <div v-else class="product-video-wrap">
            <video :src="productMp4" controls autoplay loop class="product-video" />
          </div>
        </div>
      </div>
      <!-- 产品介绍板块结束 -->
    </div>
    <!-- 板块1 -->
    <div class="title-box">
      <div class="title_text">
        多模态交互 × 智能应答
      </div>
      <div class="title_line">
        支持图文音视全媒介交互的智能客服系统
      </div>
    </div>
    <div class="section1">
      <div class="section1-inner" :class="[
        item.direction === 'right' ? 'gsap-fade-right row-reverse' : 'gsap-fade-left'
      ]" v-for="item in section1List" :key="item.title">
        <div class="section1-row">
          <div class="section1-content">
            <div class="section1-num-vertical">{{ item.num }}</div>
            <div class="section1-title-vertical">{{ item.title }}</div>
            <div class="section1-desc-vertical">{{ item.desc }}</div>
          </div>
          <div class="section1-img-wrap">
            <img :src="item.img" :alt="item.title" class="section1-img-vertical" />
          </div>
        </div>
      </div>
    </div>
    <!-- 板块1结束 -->

    <!-- 板块2 -->
    <div class="title-box">
      <div class="title_text">
        全维感知 × 决策中枢
      </div>
      <div class="title_line">
        从精准理解到增长转化的AI服务引擎
      </div>
    </div>
    <div class="section2">
      <div class="function-item function-animate" v-for="(item, index) in functions" :key="index">
        <div class="item-text">
          <div class="big-title">{{ item.title }}</div>
          <div class="small-title">{{ item.description }}</div>
        </div>
        <img :src="item.image" :alt="item.title" class="function-image" />
      </div>
    </div>
    <!-- 板块2结束 -->

    <!-- 板块3 -->
    <div class="title-box">
      <div class="title_text">
        智能驱动 × 效能跃升
      </div>
      <div class="title_line">
        以AI技术重塑服务效率与体验的智能引擎
      </div>
    </div>
    <div class="section3">
      <div class="section3-card" v-for="(item) in section3List" :key="item.title">
        <div class="section3-icon-wrap">
          <img :src="item.img" :alt="item.title" class="section3-icon" />
        </div>
        <div class="section3-title">{{ item.title }}</div>
        <div class="section3-desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import statisticscon1 from '../../assets/img/product/pc/statistics_icon1.png'
import statisticscon2 from '../../assets/img/product/pc/statistics_icon2.png'
import statisticscon3 from '../../assets/img/product/pc/statistics_icon3.png'
import statisticscon4 from '../../assets/img/product/pc/statistics_icon4.png'

import productCover from '../../assets/img/product/pc/product_cover.png'
import productMp4 from '../../assets/video/product.mp4'

import section1mg1 from '../../assets/img/product/pc/section1_img1.png'
import section1mg2 from '../../assets/img/product/pc/section1_img2.png'
import section1mg3 from '../../assets/img/product/pc/section1_img3.png'

import section3mg1 from '../../assets/img/product/pc/section3_img1.png'
import section3mg2 from '../../assets/img/product/pc/section3_img2.png'
import section3mg3 from '../../assets/img/product/pc/section3_img3.png'
import section3mg4 from '../../assets/img/product/pc/section3_img4.png'

// 新增：引入gsap和ScrollTrigger
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)


export default {
  name: 'ProductIntroPC',
  data() {
    return {
      statisticscon1,
      statisticscon2,
      statisticscon3,
      statisticscon4,
      // 统计数据
      statisticsList: [
        { title: '注册用户', value: 3000, icon: statisticscon1, currentValue: 0 },
        { title: '问题处理率', value: 95, icon: statisticscon2, currentValue: 0 },
        { title: '释放人力', value: 60, icon: statisticscon3, currentValue: 0 },
        { title: '客户满意度', value: 98.5, icon: statisticscon4, currentValue: 0 }
      ],
      // 产品介绍
      productVideoPlaying: false,
      productCover,
      productMp4,

      // 板块1
      section1mg1,
      section1mg2,
      section1mg3,

      section1List: [
        {
          num: '01',
          img: section1mg1,
          title: '图像识别与多媒体回复',
          desc: '用户可发送商品图片及商品图片、截图等，智能客服智能识别内容，并主动回复图片、视频等媒介或商品示意图，沟通更直观高效。',
          direction: 'right'
        },
        {
          num: '02',
          img: section1mg2,
          title: '语音消息实时解析',
          desc: '用户发送语音消息时，系统自动转写为文字并理解意图，支持方言识别，让不懂打字的用户也能轻松沟通。',
          direction: 'left'
        },
        {
          num: '03',
          img: section1mg3,
          title: '商品链接智能处理',
          desc: '用户发送商品链接后，智能自动解析商品信息（价格、库存、详情），并主动推荐关联商品或优惠活动，提升转化率。',
          direction: 'right'
        }
      ],

      // 板块2
      functions: [
        {
          image: require('@/assets/img/product/pc/section2_img1.png'),
          title: 'AI全天自动模式',
          description: '基于行业知识图谱和上亿条金牌客服话术打造的电商客服专有模型，7*24 全天候待命，同时应对数干请求，智能答疑',
        },
        {
          image: require('@/assets/img/product/pc/section2_img2.png'),
          title: 'AI人机协同',
          description: 'AI客服自主处理常见问题，释放人力专注疑难需求;遇到难处理的问题，智能预警人工介入，提升服务质效，客户全程无感知',
        },
        {
          image: require('@/assets/img/product/pc/section2_img3.png'),
          title: '多平台聚合管理',
          description: '聚合多个电商平台的店铺管理，所有会话一个页面展示，无需来回切回店铺，高效管理所有平台数据',
        },
        {
          image: require('@/assets/img/product/pc/section2_img4.png'),
          title: 'AI自主营销',
          description: '深入剖析客户的行为数据、浏览历史、购买偏好等多维度信息，精准识别出客户的潜在需求和消费习惯，为每个客户量身定制个性化的营销内容',
        },
        {
          image: require('@/assets/img/product/pc/section2_img5.png'),
          title: 'AI情感感知',
          description: '基于自然语言处理（NLP）和机器学习技术，能够识别客户在与客服交流过程中所表达的情感，并根据这些情感信息调整回复的语气、内容和策略',
        },
        {
          image: require('@/assets/img/product/pc/section2_img6.png'),
          title: 'AI自主学习',
          description: '三分钟快速部署基础知识库，AI自主学习商品知识，构建完整的知识库体系，实现高效的知识沉淀和复用，一次配置，长期适用',
        },
      ],

      // 板块3
      section3List: [
        {
          img: section3mg1,
          title: '解放人力',
          desc: '处理90%重复咨询，释放人工客服专注情感沟通与复杂问题，优化人效比达300%'
        },
        {
          img: section3mg2,
          title: '极速响应',
          desc: '毫秒级识别用户意图，0.5秒内生成精准回复，彻底消除排队等待，咨询响应率达100%'
        },
        {
          img: section3mg3,
          title: '精准解答',
          desc: '基于千亿级大模型训练，对商品参数、售后政策等标准化问题解答准确率超98%，首次解决率提升85%'
        },
        {
          img: section3mg4,
          title: '体验升级',
          desc: '个性化推荐与上下文记忆能力，使客户满意度提升40%，复购率累计增长25%'
        }
      ],

    }
  },
  methods: {
    playproductVideo() {
      this.productVideoPlaying = true;
    },
    animateNumber(idx, target, duration = 1000) {
      const start = 0;
      const isPercent = target <= 100;
      const end = target;
      const startTime = performance.now();
      const step = (now) => {
        const elapsed = now - startTime;
        let progress = Math.min(elapsed / duration, 1);
        let value = start + (end - start) * progress;
        if (isPercent) {
          value = Math.round(value * 10) / 10;
        } else {
          value = Math.floor(value);
        }
        this.$set(this.statisticsList, idx, {
          ...this.statisticsList[idx],
          currentValue: value
        });
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          this.$set(this.statisticsList, idx, {
            ...this.statisticsList[idx],
            currentValue: end
          });
        }
      };
      requestAnimationFrame(step);
    }
  },
  // 新增：mounted钩子注册动画
  mounted() {
    if (gsap && gsap.utils && gsap.fromTo) {
      // section1 动画方向
      gsap.utils.toArray('.gsap-fade-left').forEach(el => {
        gsap.fromTo(el, { x: -100, opacity: 0 }, {
          x: 0, opacity: 1, duration: 1, ease: "power2.out",
          scrollTrigger: { trigger: el, start: "top 80%", end: "top 30%", toggleActions: "restart none none reverse" }
        });
      });
      gsap.utils.toArray('.gsap-fade-right').forEach(el => {
        gsap.fromTo(el, { x: 100, opacity: 0 }, {
          x: 0, opacity: 1, duration: 1, ease: "power2.out",
          scrollTrigger: { trigger: el, start: "top 80%", end: "top 30%", toggleActions: "restart none none reverse" }
        });
      });
      // 板块2 动画
      gsap.utils.toArray('.function-animate').forEach((el, i) => {
        gsap.fromTo(el,
          { scale: 0.8, opacity: 0, y: 60 },
          {
            scale: 1, opacity: 1, y: 0,
            duration: 0.8, delay: i * 0.15,
            ease: "elastic.out(1, 0.6)",
            scrollTrigger: {
              trigger: el,
              start: "top 85%",
              toggleActions: "play none none reverse"
            }
          }
        );
      });
      // 其他动画
      gsap.utils.toArray('.gsap-fade-up').forEach(el => {
        gsap.fromTo(el,
          { y: 60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      gsap.utils.toArray('.gsap-fade-down').forEach(el => {
        gsap.fromTo(el,
          { y: -60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      // 统计板块数字动画
      ScrollTrigger.create({
        trigger: '.statistics-section',
        start: 'top 80%',
        once: true,
        onEnter: () => {
          this.statisticsList.forEach((item, idx) => {
            this.animateNumber(idx, item.value, 1200);
          });
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
.page-content-pc {
  margin-top: 64px;
  width: 100%;
  // overflow-x: hidden;
  min-width: max-content;

  .banner {
    height: 520px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    background: url('../../assets/img/product/pc/banner.png') no-repeat center center;
    background-size: cover;
    margin-bottom: 68px;

    .introduce {
      width: 1280px;
      margin: 0 auto;

      .introduce_title {
        font-weight: bold;
        font-size: 42px;
        color: #1D203D;
      }

      .introduce_desc {
        width: 714px;
        font-weight: 500;
        font-size: 34px;
        color: #1D203D;
        margin-top: 54px;
      }
    }
  }

  .title-box {
    display: flex;
    flex-wrap: wrap;
    text-align: center;

    .title_text {
      width: 100%;
      display: inline-block;
      font-weight: 800;
      font-size: 40px;
      line-height: 56px;
      font-style: normal;
      text-transform: none;
      background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
      margin-bottom: 14px;
    }

    .title_line {
      width: 100%;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 34px;
      font-style: normal;
      text-transform: none;
    }
  }

  .content {
    width: 1280px;
    margin: 0 auto;
    height: 100%;

    // 统计板块
    .statistics-section {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -140px;
      margin-bottom: 80px;

      .statistics-inner {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.5) 100%);
        box-shadow: 0px 5px 15px 0px rgba(38, 71, 124, 0.15);
        border-radius: 16px 16px 16px 16px;
        border: 1px solid #FFFFFF;
        padding: 30px 20px;
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
      }

      .statistics-item {
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: center;
        min-width: 0;
      }

      .statistics-icon {
        width: 100px;
        height: 80px;
        margin-right: 20px;
        object-fit: contain;
        flex-shrink: 0;
      }

      .statistics-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
      }

      .statistics-value {
        font-weight: 800;
        font-size: 32px;
        color: #000000;
        text-align: right;
      }

      .statistics-title {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        margin-top: 4px;
      }
    }
  }

  // 产品介绍板块
  .product-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 80px;

    .product-left {
      width: 542px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      // padding-right: 40px;

      .product-title {
        font-weight: 800;
        font-size: 40px;
        background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
        margin-bottom: 12px;
      }

      .product-subtitle {
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        margin-bottom: 32px;
      }

      .product-desc {
        text-indent: 1em;
        font-weight: 500;
        font-size: 14px;
        color: #6F6F6F;
      }
    }

    .product-right {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 674px;
      height: 366px;
      border: 4px solid #0051FF;
      overflow: hidden;
      border-radius: 12px;

      .product-cover-wrap {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .product-cover-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .product-play-btn {
          width: 42px;
          height: 58px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          cursor: pointer;
          z-index: 2;
          transition: transform 0.2s;

          &:hover {
            transform: translate(-50%, -50%) scale(1.08);
          }
        }
      }

      .product-video-wrap {
        width: 100%;
        height: 367px;
        display: flex;
        align-items: center;
        justify-content: center;

        .product-video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
    }
  }
}

.section1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 28px;
  margin-bottom: 60px;

  @media screen and (min-width: 1200px) {
    overflow-x: hidden;
  }

  .section1-inner {
    border-radius: 18px;

    &.row-reverse {
      background: #F8FEFF;
    }

    .section1-row {
      width: 1280px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      padding: 20px;
      flex-direction: row;
      justify-content: space-between;
    }

    &.row-reverse .section1-row {
      flex-direction: row-reverse;
    }

    .section1-img-wrap {
      width: 601px;
      height: 328px;

      .section1-img-vertical {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
    }

    .section1-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 535px;

      .section1-num-vertical {
        font-weight: 800;
        font-size: 48px;
        text-transform: none;
        background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
        margin-bottom: 8px;
      }

      .section1-title-vertical {
        font-weight: 800;
        font-size: 32px;
        color: #222;
        margin-bottom: 20px;
      }

      .section1-desc-vertical {
        font-weight: 800;
        font-size: 16px;
        color: #6F6F6F;
      }
    }
  }


}

.section2 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  width: 1280px;
  margin: 0 auto;
  margin-top: 48px;
  margin-bottom: 80px;

  @keyframes float {
    0% {
      transform: translateY(0) rotate(0deg);
    }

    50% {
      transform: translateY(-15px) rotate(2deg);
    }

    100% {
      transform: translateY(0) rotate(0deg);
    }
  }

  @keyframes textGlow {
    0% {
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }

    50% {
      text-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    }

    100% {
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }
  }

  .function-item {
    position: relative;
    background: linear-gradient(135deg, #E5F7FF 0%, #F8FDFF 48%, #E5F7FF 100%);
    border-radius: 6px;
    padding: 36px 24px 0 24px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 456px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(37, 77, 255, 0.1) 0%, rgba(37, 77, 255, 0) 100%);
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

      &::after {
        opacity: 1;
      }

      .function-image {
        animation: float 1.5s ease-in-out infinite;
        filter: drop-shadow(0 10px 15px rgba(0, 0, 0, 0.1));
      }

      .item-text {
        .big-title {
          transform: translateX(10px);
          color: #1a1a1a;
          text-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }

        .small-title {
          transform: translateX(5px);
          color: #333333;
        }
      }
    }

    .item-text {
      width: 320px;

      .big-title {
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 18px;
        transition: all 0.3s ease;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 0;
          height: 2px;
          background: #1a1a1a;
          transition: width 0.3s ease;
        }
      }

      .small-title {
        font-weight: 500;
        font-size: 16px;
        color: #666666;
        transition: all 0.3s ease;
      }
    }

    .function-image {
      width: 176.39px;
      height: 198px;
      position: absolute;
      bottom: 26px;
      right: 26px;
      transition: all 0.3s ease;
    }
  }
}

.section3 {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 27px;

  .section3-card {
    flex: 1;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0px 4px 14px 3px rgba(168, 197, 254, 0.27);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 22px 40px 22px;
    min-width: 0;
    transition: box-shadow 0.2s;
    position: relative;
    margin-top: 60px;
    margin-bottom: 103px;

    &:hover {
      box-shadow: 0 8px 32px 0 rgba(0, 76, 255, 0.12);
    }

    .section3-icon-wrap {
      width: 64px;
      height: 64px;
      margin-bottom: 16px;

      .section3-icon {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
    }

    .section3-title {
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      margin-bottom: 20px;
      text-align: center;
    }

    .section3-desc {
      font-weight: 500;
      font-size: 16px;
      color: #6F6F6F;
    }
  }
}
</style>